import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const appRoutes = {
  path: "/",
  name: "main",
  meta: {
    title: "main",
  },
  redirect: '/account',
  component: () => import('../views/layout/main.vue'),
  children: [//页面路由
    {
      path: "/account",
      name: "account",
      component: () => import('../views/account/index.vue'),
      meta: {
        isMenu: true,
        title: "账号管理",
        keepAlive: true,
      }
    },
    {
      path: "/account/poi",
      name: "accountPoi",
      component: () => import('../views/account/poi/index.vue'),
      meta: {
        title: "poi地址",
        isMenu: false,
        parentName: "account",
        keepAlive: false,
      },
    },
    {
      path: "/intelligent",
      name: "intelligent",
      component: () => import('../views/intelligent/index.vue'),
      meta: {
        title: "视频创作",
        isMenu: true,
        keepAlive: false,
      },
      children: [
        {
          path: "/tool/extractAudio",
          name: "extractAudio",
          component: () => import('../views/intelligent/tool/extractAudio.vue'),
          meta: {
            title: "提取音频",
            isMenu: false,
            parentName: "intelligent",
            keepAlive: false,
          },
        },
        {
          path: "/tool/audioOutput",
          name: "audioOutput",
          component: () => import('../views/intelligent/tool/audioOutput.vue'),
          meta: {
            title: "输出音频",
            isMenu: false,
            parentName: "intelligent",
            keepAlive: false,
          },
        },
        {
          path: "/tool/videoPlayback",
          name: "videoPlayback",
          component: () => import('../views/intelligent/tool/videoPlayback.vue'),
          meta: {
            title: "视频倒放",
            isMenu: false,
            parentName: "intelligent",
            keepAlive: false,
          },
        },
        {
          path: "/tool/extractVideo",
          name: "extractVideo",
          component: () => import('../views/intelligent/tool/extractVideo.vue'),
          meta: {
            title: "提取视频",
            isMenu: false,
            parentName: "intelligent",
            keepAlive: false,
          },
        },
        {
          path: "/tool/removeWatermark",
          name: "removeWatermark",
          component: () => import('../views/intelligent/tool/removeWatermark.vue'),
          meta: {
            title: "视频去水印",
            isMenu: false,
            parentName: "intelligent",
            keepAlive: false,
          },
        },
        {
          path: "/tool/videoRename",
          name: "videoRename",
          component: () => import('../views/intelligent/tool/videoRename.vue'),
          meta: {
            title: "文件名过滤",
            isMenu: false,
            parentName: "intelligent",
            keepAlive: false,
          },
        },
        {
          path: "/tool/videoClip",
          name: "videoClip",
          component: () => import('../views/intelligent/tool/videoClip.vue'),
          meta: {
            title: "视频裁剪",
            isMenu: false,
            parentName: "intelligent",
            keepAlive: false,
          },
        },
        {
          path: "/tool/videoRevolve",
          name: "videoRevolve",
          component: () => import('../views/intelligent/tool/videoRevolve.vue'),
          meta: {
            title: "视频旋转",
            isMenu: false,
            parentName: "intelligent",
            keepAlive: false,
          },
        },
      ]
    },
    {
      path: "/videoPublish",
      name: "videoPublish",
      component: () => import('../views/video-publish/index.vue'),
      meta: {
        title: "视频发布",
        isMenu: true,
        keepAlive: false,
      },
    },
    // {
    //   path: "/dataCenter",
    //   name: "dataCenter",
    //   component: () => import('../views/dataCenter/index.vue'),
    //   meta: {
    //     isMenu: true,
    //     title: "数据中心",
    //     keepAlive: false,
    //   }
    // },
  ],
}

const routes = [
  {
    path: "/login",
    name: "login",
    component: () => import('../views/login/index.vue'),
    meta: {
      title: "登录",
    },
  },
  appRoutes,
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

//解决 Vue 路由传递爹数时，出现 Uncaught (in promise) NavigationDuplicated: Avoided redundant navigation 问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const appRouter = appRoutes.children

export {
  appRouter
}

export default router;
